import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import CustomButton from "../../components/common-components/CustomButton";
import { useParams } from "react-router";
import { updateStatus } from "../../stores/orders";
import { useAppDispatch } from "../../stores/store";
import DocumentUploadModal from "./DocumentUploadModal";
import { setToast } from "../../stores/toast/toastslice";
import { useSelector } from "react-redux";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";

interface titleData {
  title?: string;
  title1?: string;
  description?: string;
  status?: any;
  productId?: string;
  onSuccessUpload?: () => void;
  loading?: boolean;
  taxOrderData?: any;
}

const OrderDetailTitleBar = (props: titleData) => {
  const {
    title,
    description,
    title1,
    status,
    productId,
    onSuccessUpload,
    loading,
    taxOrderData,
  } = props;
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const numericProductId = Number(productId);
  // console.log(numericProductId,"numericProductId")
  const numericStatus = Number(status);
  const [localStatus, setLocalStatus] = useState<number>(numericStatus);
  const [open, setOpen] = useState(false);
  const { updateStatusState } = useSelector((state: any) => state.orders);
  // const { btnStatus } = useSelector((state: any) => state.orders);
  // console.log(btnStatus,"btnStatus")
const orderStatus = taxOrderData?.tax_filing_file?.save_as_draft;
console.log(taxOrderData?.tax_filing_file)
  useEffect(() => {
    if (status !== undefined) {
      setLocalStatus(Number(status));
    }
  }, [status]);

  const itinStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: {
      label: "Ready For Signature",
      bgColor: "#FFF5DB",
      textColor: "#E7AB12",
    },
    2: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    3: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    4: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
  };

  const IncorporationStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    2: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    3: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    4: {
      label: "Ready For Signature",
      bgColor: "#FFF5DB",
      textColor: "#E7AB12",
    },
    5: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    6: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    7: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
  };
const taxFilingStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
   
  };
  const statusMap =
    numericProductId === 2
      ? IncorporationStatus
      : numericProductId === 1
      ? itinStatus
      : {};
  const statusDetails = statusMap[localStatus];

  const showSubmitButton =
    (numericProductId === 2 && (localStatus === 1 || localStatus === 5)) ||
    (numericProductId === 1 && localStatus === 2);

  const showUploadButton =
    (numericProductId === 2 && (localStatus === 2 || localStatus === 6)) ||
    (numericProductId === 1 && localStatus === 3);

  const handleStatusUpdate = async () => {
    if (!id) return;
    let fileType: number | null = null;

    if (numericProductId === 2) {
      if (localStatus === 1) fileType = 0;
      else if (localStatus === 5) fileType = 1;
    } else if (numericProductId === 1 && localStatus === 2) {
      fileType = 2;
    }

    if (fileType !== null) {
      const res = await dispatch<any>(
        updateStatus({ order_id: id, file_type: fileType })
      ).unwrap();
      if (res?.updatedStatus !== undefined) {
        setLocalStatus(res.updatedStatus);
        dispatch<any>(setToast({ type: "success", message: res?.message }));
      } else {
        setLocalStatus((prev) => prev + 1);
      }
    }
  };

  const handleUploadSuccess = (updatedStatus?: number) => {
    if (updatedStatus !== undefined) {
      setLocalStatus(updatedStatus);
    } else {
      setLocalStatus((prev) => prev + 1);
    }

    if (onSuccessUpload) {
      onSuccessUpload();
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // paddingTop: "10px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "24px",
              color: theme.palette.myCustomColor.heading,
              whiteSpace: "nowrap",
            }}
          >
            {title}{" "}
            <span
              style={{ fontWeight: 700, fontSize: "24px", color: "#060110" }}
            >
              {title1}
            </span>
          </Typography>
          <Typography variant="h4" sx={{ color: "#6C6F71" }}>
            {description}
          </Typography>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", alignItems: "center", height: "36px" }}>
            <ListLoadingNew />
          </Box>
        ) : status !== undefined ? (
          <Box sx={{ display: "flex", gap: 2 }}>
            {statusDetails && (
              <Box
                sx={{
                  width: "auto",
                  borderRadius: "27px",
                  fontSize: "14px",
                  fontWeight: 500,
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  display: "inline-block",
                  padding: "16px 24px",
                  backgroundColor: statusDetails.bgColor || "#ccc",
                  color: statusDetails.textColor || "#000",
                }}
              >
                {statusDetails.label || "Unknown"}
              </Box>
            )}
            {Number(productId)===3 && (
             <Box
                sx={{
                  width: "auto",
                  borderRadius: "27px",
                  fontSize: "14px",
                  fontWeight: 500,
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  display: "inline-block",
                  padding: "16px 24px",
                  backgroundColor: orderStatus? "#FFF5DB" : "#EAF1FA",
                  color: orderStatus? "#E7AB12" : "#2977CC",
                }}
              >
                {orderStatus? "Pending":"submitted" }
              </Box>
            )}

            {showUploadButton && (
              <CustomButton
                btnTitle="Upload Document"
                sx={{
                  width: "160px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  padding: "8px 16px",
                }}
                type="button"
                handleClick={() => setOpen(true)}
              />
            )}

            {showSubmitButton && (
              <CustomButton
                btnTitle="Submit"
                sx={{ width: "150px" }}
                type="button"
                handleClick={handleStatusUpdate}
                loading={updateStatusState === "loading"}
              />
            )}
          </Box>
        ) : null}
      </Box>

      {/* Upload Modal */}
      {open && (
        <DocumentUploadModal
          open={open}
          handleClose={() => setOpen(false)}
          id={Number(id)}
          onSuccess={handleUploadSuccess}
          status={localStatus}
          productId={numericProductId}
        />
      )}
    </>
  );
};

export default OrderDetailTitleBar;
